import request from '@/utils/http';


// 查询个人信息
export function getUserInfo() {
  return request({
    url: '/mall/user/getUserInfo',
    method: 'get'
  });
}

// 查询个人信息
// // 查询
// export    function findIntegralListBySearch  (data) {
//   return request({
//      url: '/mall/integral/findIntegralListBySearch',
//     method: 'post',
//     data
//   });
// }

// 获取专属客户经理信息
export function getSalesManager() {
  return request({
    url: '/mall/user/getSalesManager',
    method: 'get'
  });
}
